"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _ThemeProvider = require("../../theme/ThemeProvider");

var _classnames = _interopRequireDefault(require("classnames"));

var _lodash = require("lodash");

var EntypoIcons = _interopRequireWildcard(require("react-entypo-icons"));

var _CustomIcon = _interopRequireDefault(require("./CustomIcon"));

var styles = {
  Icon: {
    verticalAlign: 'middle',
    '&.medium': {
      fontSize: '1.3em'
    },
    '&.large': {
      fontSize: '2em',
      width: '23px',
      height: '23px'
    },
    '&.inactive': {
      opacity: '0.6'
    }
  }
};
var useStyles = (0, _ThemeProvider.createUseStyles)(styles);

var Icon = function Icon(_ref) {
  var glyph = _ref.glyph,
      className = _ref.className,
      rest = (0, _objectWithoutProperties2["default"])(_ref, ["glyph", "className"]);
  var classes = useStyles(); // convert glyph string into upper camel case

  var type = glyph && glyph.split('-').map(function (item) {
    return (0, _lodash.capitalize)(item);
  }).join('');

  if (!glyph) {
    type = 'MagnifyingGlass';
  }

  var IconComponent = EntypoIcons["Entypo".concat(type)];

  if (IconComponent) {
    return /*#__PURE__*/_react["default"].createElement(IconComponent, (0, _extends2["default"])({
      className: (0, _classnames["default"])(classes.Icon, className),
      valign: true
    }, rest));
  }

  return /*#__PURE__*/_react["default"].createElement(_CustomIcon["default"], (0, _extends2["default"])({
    className: (0, _classnames["default"])(classes.Icon, className),
    glyph: type || ''
  }, rest));
};

var _default = Icon;
exports["default"] = _default;
//# sourceMappingURL=index.js.map